module.exports = __webpack_public_path__ + "static/media/m-perform.cc79266e.pdf";